module.exports = __webpack_public_path__ + "static/img/1035.e73685e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1035.jpg
// module id = 217
// module chunks = 0